import React from 'react';
import './Speakers from.css';
import aws from "../../img/SF/aws.png";
import Calendly from "../../img/SF/Calendly.png";
import RedHat from "../../img/SF/RedHat.png";
import WIX from "../../img/SF/WIX.png";
import Netflix from "../../img/SF/Netflix.png";
import EPAM from "../../img/SF/EPAM.png";
import Microsoft from "../../img/SF/Microsoft.png";
import Google from "../../img/SF/google.png";
import Accenture from "../../img/SF/Accenture.png";
import Figma from "../../img/SF/Figma.png";
import IBM from "../../img/SF/IBM.png";
import SAP from "../../img/SF/sap.png";
import Adobe from "../../img/SF/Adobe.png";
import Linkedin from "../../img/SF/LinkedIn.png";
import GitHub from "../../img/SF/github.png";
import Oracle from "../../img/SF/Oracle.png";
import PayPal from "../../img/SF/PayPal.png";
import Nasa from "../../img/SF/NASA.png";

const SpeakersFrom = () => {
    const state = {
        Speakers_item: [
            {
                img: Netflix,
            },
            {
                img: RedHat,
            },
            {
                img: aws,
            },
            {
                img: WIX,
            },
            {
                img: Microsoft,
            },
            {
                img: Calendly,
            },
            {
                img: EPAM,
            },
            {
                img: Google,
            },
            {
                img: Accenture,
            },
            {
                img: Figma,
            },
            {
                img: IBM,
            },
            {
                img: SAP,
            },
            {
                img: Adobe,
            },
            {
                img: Linkedin,
            },
            {
                img: GitHub,
            },
            {
                img: Oracle,
            },
            {
                img: PayPal,
            },
            {
                img: Nasa,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt={item.alt} />
            </div>
        );
    };

    return (
        <section className="speakers_from_wrap ">
            <div className="container">
                <h2>Speakers from previous events</h2>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </section>
    );
};

export default SpeakersFrom;